import { useGenericSocket } from "@/hooks/useGenericSocket";
import {
  BINANCE_RESOLUTION_MAP,
  BINANCE_RESOLUTION_MAP_REVERSE,
} from "@/lib/datafeed/config";
import { getVWAPScreenerTopic, SocketTopics } from "@/lib/natsConnection";
import { useCallback } from "react";
import { z } from "zod";

/**
 * VWAP Screener row type
 * side: "DOWN" | "UP"
 * symbol: string
 * vwap: number
 * vwapToClosePrc: number
 * vwapToStdDevPrc: number
 */
export interface IVWAPScreenerRow {
  side: "DOWN" | "UP";
  symbol: string;
  vwap: number;
  vwapToClosePrc: number;
  vwapToStdDevPrc: number;
}

/**
 * VWAP Screener response type
 */
export interface IVWAPScreenerResponse {
  timestamp: number;
  timeFrame: string;
  exchange: string;
  exchangeType: string;
  data: IVWAPScreenerRow[];
}

const VWAPScreenerRowSchema = z.object({
  symbol: z.string(),
  period: z.string(),
  value: z.number(),
  toClosePrc: z.number(),
});

const VWAPScreenerResponseSchema = z.object({
  timestamp: z.number(),
  timeFrame: z.string(),
  data: z.array(VWAPScreenerRowSchema),
});

/**
 * Hook to subscribe to VWAP Screener NATS topic and return validated data
 */
export function useVWAPScreener(timeframe: string) {
  const handler = useCallback(
    (_: IVWAPScreenerResponse, newData: IVWAPScreenerResponse) => {
      return newData;
    },
    [],
  );

  return useGenericSocket<IVWAPScreenerResponse, IVWAPScreenerResponse>(
    getVWAPScreenerTopic(timeframe as "5m" | "15m" | "1h" | "4h"),
    handler,
  );
}
